import { render, staticRenderFns } from "./ProspectSecondPageUrl.vue?vue&type=template&id=1c2dc0be&scoped=true"
import script from "./ProspectSecondPageUrl.vue?vue&type=script&lang=js"
export * from "./ProspectSecondPageUrl.vue?vue&type=script&lang=js"
import style0 from "./ProspectSecondPageUrl.vue?vue&type=style&index=0&id=1c2dc0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2dc0be",
  null
  
)

export default component.exports